export enum SequentialBlockTypes {
  TEXT = 'TEXT',
  HEADER = 'HEADER',
  IMAGE = 'IMAGE',
  DESCRIPTION = 'DESCRIPTION',
  SEPARATOR = 'SEPARATOR',
  LIST_ITEM = 'LIST_ITEM',
}
export interface SequentialBlock {
  key?: string | number;
  sequenceNumber: number;
  type: SequentialBlockTypes;
  value: string;
}
